module.exports = __webpack_public_path__ + "media/images/result_sets/circles/1n2r7r4r-71beece923132929a4b0c190911cb630.svg";